<template>
	<div v-if="loading">
	</div>
	<div v-else-if="user.beta">
		<div>
			<vx-card title="Terugkerende korting">
				<vs-alert color="danger">LET OP! Deze module is nog in Béta! Niet alles zal naar verwachting werken. Gebruik op eigen risico.</vs-alert>
				<div class="w-full vx-row">
					<div class="vx-col w-full ">
						<br>
						<label>
							<b>Wat is terugkerende korting?</b><br>
							Een terugkerende korting is handig op moment de je op vaste momenten bijvoorbeeld wekelijks of maandelijks korting wil toepassen op je gehele aanbod.
							Deze korting kun je bijvoorbeeld iedere vrijdag om 20:00 laten beginnen en zondag om 17:00 laten eindigen. Boldashboard zorgt er dan voor dat de
							prijzen voor <u>alle</u> producten in je aanbod worden aangepast. Je kunt dit doen met een korting uitgedrukt in euro's of procenten.<br><br>
						</label>
						<label>
							<b>Hoe werkt het?</b><br>
							Stel je maakt een terugkerende korting aan van vrijdag 20:00 tot en met zondag 17:00 en je wilt 10% korting geven.<br>
							<br>
							Vrijdag avond vanaf 19:50 begint boldashboard automatisch met de prijzen van je aanbod op te slaan, zo kunnen de prijzen op zondag weer aangepast
							worden naar de 'oude' prijzen. Daarna wordt de prijs voor het product verlaagt met 10%. Op zondag vanaf 16:50 worden de prijzen automatisch weer
							teruggezet naar de 'oude' prijs.<br>
							<br>
							<b>Werkt het ook met staffelkorting?</b><br>
							Ja, zeker! Stel je verkoopt een product voor 20 euro, hebt de staffels 2 stuks = 10% (18 euro), 3 stuks = 15% (17 euro) en 5 stuks = 20% (16 euro).<br>
							<br>
							Bij het aanpassen van de prijzen worden ook je staffel prijzen opgeslagen en herberekend. De percentage van je staffelkorting blijven gelijk. In dit
							voorbeeld worden de prijzen dus 1 stuk = 18 euro, 2 stuks = 16,2 euro 3 stuks = 15,3 euro en 5 stuks = 14,40 euro. Als de kortingsperiode afgelopen
							is gaan ook de staffelprijzen weer terug naar de 'oude' staffels.
						</label>
					</div>
					<div v-if="!modulePromotion.active" class="vx-col w-full mt-5">
						<vs-button color="primary" type="filled" @click.native="activateModule">Activeer deze module</vs-button>
						<br>
					</div>
				</div>
			</vx-card>
		</div>
		<div>
			<vx-card v-if="modulePromotion.active" title="Korting instellen" class="mt-5">
				<div class="w-full vx-row">
					<div class="vx-col w-full">
						<vs-divider position="left">Hoe vaak</vs-divider>
					</div>

					<div class="vx-col w-full ">
						<label class="multiselect-label">Selecteer een frequentie</label>
						<vue-multiselect
							v-model="form.type"
							placeholder="Selecteer een frequentie"
							:options="options.type"
							:allow-empty="false"
							:show-labels="false"
							label="label"
							track-by="id"
						/>
					</div>

					<div class="vx-col w-full">
						<vs-divider position="left">Begin</vs-divider>
					</div>

					<div class="vx-col w-8/12" v-if="form.type.id === 1">
						<label class="multiselect-label">Selecteer dag van de week</label>
						<vue-multiselect
							v-model="form.startDayOfWeek"
							placeholder="Selecteer dag van de week"
							:options="options.dayOfWeek"
							:allow-empty="false"
							:show-labels="false"
							label="label"
							track-by="id"
						/>
					</div>

					<div class="vx-col w-8/12" v-if="form.type.id === 2">
						<label class="multiselect-label">Selecteer dag van de maand</label>
						<vue-multiselect
							v-model="form.startDayOfMonth"
							placeholder="Selecteer dag van de maand"
							:options="options.dayOfMonth"
							:allow-empty="false"
							:show-labels="false"
							label="label"
							track-by="id"
						/>
					</div>

					<div class="vx-col w-4/12">
						<label class="multiselect-label">Selecteer een tijd</label><br>
						<vue-timepicker v-model="form.startTime" minute-interval="5"></vue-timepicker>
					</div>

					<div class="vx-col w-full">
						<vs-divider position="left">Eind</vs-divider>
					</div>

					<div class="vx-col w-8/12" v-if="form.type.id === 1">
						<label class="multiselect-label">Selecteer dag van de week</label>
						<vue-multiselect
							v-model="form.endDayOfWeek"
							placeholder="Selecteer dag van de week"
							:options="options.dayOfWeek"
							:allow-empty="false"
							:show-labels="false"
							label="label"
							track-by="id"
						/>
					</div>

					<div class="vx-col w-8/12" v-if="form.type.id === 2">
						<label class="multiselect-label">Selecteer dag van de maand</label>
						<vue-multiselect
							v-model="form.endDayOfMonth"
							placeholder="Selecteer dag van de maand"
							:options="options.dayOfMonth"
							:allow-empty="false"
							:show-labels="false"
							label="label"
							track-by="id"
						/>
					</div>

					<div class="vx-col w-4/12">
						<label class="multiselect-label">Selecteer een tijd</label><br>
						<vue-timepicker v-model="form.endTime" minute-interval="5"></vue-timepicker>
					</div>

					<div class="vx-col w-full">
						<vs-divider position="left">Korting</vs-divider>
					</div>

					<div class="vx-col w-8/12 ">
						<label class="multiselect-label">Selecteer een korting type</label>
						<vue-multiselect
							v-model="form.discountType"
							placeholder="Selecteer een korting type"
							:options="options.discountType"
							:allow-empty="false"
							:show-labels="false"
							label="label"
							track-by="id"
						/>
					</div>

					<div class="vx-col w-4/12" v-if="form.discountType.id === 1">
						<label>Selecteer een kortings percentage</label>
						<vs-input-number v-model="form.discountPercentage" />
					</div>

					<div class="vx-col w-4/12" v-if="form.discountType.id === 2">
						<label>Selecteer een kortings bedrag</label>
						<vs-input type="number" step="0.05" placeholder="euro" v-model="form.discountEuro" />
					</div>
				</div>

				<div class="vx-col w-full mt-5">
					<label>Korting actief</label>
					<vs-switch v-model="form.active" />
				</div>

				<div class="vx-col w-full mt-5">
					<vs-button color="primary" type="filled" @click.native="save">Opslaan</vs-button>
				</div>
			</vx-card>
		</div>
		<div>
			<vx-card v-if="modulePromotion.active" title="Module deactiveren" class="mt-5">
				<div class="w-full vx-row">
					<div class="vx-col w-full ">
						<vs-button color="danger" type="filled" @click.native="deactivateModule">Deactiveer deze module</vs-button>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
	<div v-else>
		<vx-card title="Terugkerende korting">
			<vs-alert color="warning">Helaas, deze module is nog alleen voor béta testers beschikbaar. Ook béta tester worden? Meld je aan via info@boldashboard.nl</vs-alert>
		</vx-card>
	</div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {Validator} from 'vee-validate';
import {mapGetters} from 'vuex';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

Vue.use(VeeValidate);

const dict = {
	custom: {
		publicKey: {
			required: 'Vul hier je publieke sleutel in.',
			length: 'Vul 32 karakers in.',
		},
		privateKey: {
			required: 'Vul hier je geheime sleutel in.',
			length: 'Vul 32 karakers in.',
		},
	}
};
Validator.localize('en', dict);

export default {
	components: {
		VueTimepicker
	},
	data() {
		return {
			loading: true,
			form: {
				type: {
					id: 1,
					label: 'Wekelijks'
				},
				startDayOfWeek: {
					id: 5,
					label: 'Vrijdag',
				},
				startDayOfMonth: {
					id: 5,
					label: '5',
				},
				startTime: '19:30',
				endDayOfWeek: {
					id: 0,
					label: 'Zondag',
				},
				endDayOfMonth: {
					id: 10,
					label: '10',
				},
				endTime: '23:30',
				discountType: {
					id: 1,
					label: 'Percentage'
				},
				discountPercentage: 1,
				discountEuro: null,
				active: false,
			},
			options: {
				type: [
					{
						id: 1,
						label: 'Wekelijks'
					},
					{
						id: 2,
						label: 'Maandelijks'
					},
				],
				dayOfWeek: [
					{
						id: 1,
						label: 'Maandag',
					},
					{
						id: 2,
						label: 'Dinsdag',
					},
					{
						id: 3,
						label: 'Woensdag',
					},
					{
						id: 4,
						label: 'Donderdag',
					},
					{
						id: 5,
						label: 'Vrijdag',
					},
					{
						id: 6,
						label: 'Zaterdag',
					},
					{
						id: 0,
						label: 'Zondag',
					},
				],
				dayOfMonth: [
					{
						id: 1,
						label: '1',
					},
					{
						id: 2,
						label: '2',
					},
					{
						id: 3,
						label: '3',
					},
					{
						id: 4,
						label: '4',
					},
					{
						id: 5,
						label: '5',
					},
					{
						id: 6,
						label: '6',
					},
					{
						id: 7,
						label: '7',
					},
					{
						id: 8,
						label: '8',
					},
					{
						id: 9,
						label: '9',
					},
					{
						id: 10,
						label: '10',
					},
					{
						id: 11,
						label: '11',
					},
					{
						id: 12,
						label: '12',
					},
					{
						id: 13,
						label: '13',
					},
					{
						id: 14,
						label: '14',
					},
					{
						id: 15,
						label: '15',
					},
					{
						id: 16,
						label: '16',
					},
					{
						id: 17,
						label: '17',
					},
					{
						id: 18,
						label: '18',
					},
					{
						id: 19,
						label: '19',
					},
					{
						id: 20,
						label: '20',
					},
					{
						id: 21,
						label: '21',
					},
					{
						id: 22,
						label: '22',
					},
					{
						id: 23,
						label: '23',
					},
					{
						id: 24,
						label: '24',
					},
					{
						id: 25,
						label: '25',
					},
					{
						id: 26,
						label: '26',
					},
					{
						id: 27,
						label: '27',
					},
					{
						id: 28,
						label: '28',
					},
					{
						id: 29,
						label: '29',
					},
					{
						id: 30,
						label: '30',
					},
					{
						id: 31,
						label: '31',
					},
				],
				discountType: [
					{
						id: 1,
						label: 'Percentage'
					},
					{
						id: 2,
						label: 'Vast bedrag'
					},
				],
			}
		};
	},
	computed: {
		...mapGetters({
			modulePromotion: 'promotion/modulePromotion',
			promotion: 'promotion/promotion',
			user: 'userStore/user'
		})
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			if (this.user.beta) {
				this.$vs.loading();
				this.$store.dispatch('promotion/init').then(res => {
					if (this.promotion && Object.keys(this.promotion).length) {
						this.form.type = this.castFieldValue(this.options.type, this.promotion.type);
						if (this.form.type.id === 1) {
							this.form.startDayOfWeek = this.castFieldValue(this.options.dayOfWeek, this.promotion.start_day);
							this.form.endDayOfWeek = this.castFieldValue(this.options.dayOfWeek, this.promotion.end_day);
						} else if (this.form.type.id === 2) {
							this.form.startDayOfMonth = this.castFieldValue(this.options.dayOfMonth, this.promotion.start_day);
							this.form.endDayOfMonth = this.castFieldValue(this.options.dayOfMonth, this.promotion.end_day);
						}
						this.form.startTime = this.promotion.start_time;
						this.form.endTime = this.promotion.end_time;
						this.form.discountType = this.castFieldValue(this.options.discountType, this.promotion.discount_type);
						if (this.form.discountType.id === 1) {
							this.form.discountPercentage = this.promotion.discount;
						} else if (this.form.discountType.id === 2) {
							this.form.discountEuro = this.promotion.discount;
						}
						this.form.active = this.promotion.active;
					}

					this.$vs.loading.close();
					this.loading = false;
				});
			} else {
				this.loading = false;
			}
		},
		castFieldValue(options, valueId) {
			let castedOption = null;

			options.forEach(option => {
				if (option.id === valueId) {
					castedOption = option;
				}
			});

			return castedOption;
		},
		save() {
			const params = {
				type: this.form.type.id,
			}

			if (this.form.type.id === 1) {
				params.start_day = this.form.startDayOfWeek.id;
				params.start_time = this.form.startTime;
				params.end_day = this.form.endDayOfWeek.id;
				params.end_time = this.form.endTime;
			}

			if (this.form.type.id === 2) {
				params.start_day = this.form.startDayOfMonth.id;
				params.start_time = this.form.startTime;
				params.end_day = this.form.endDayOfMonth.id;
				params.end_time = this.form.endTime;
			}

			params.discount_type = this.form.discountType.id;

			if (this.form.discountType.id === 1) {
				params.discount = this.form.discountPercentage;
			}

			if (this.form.discountType.id === 2) {
				params.discount = parseFloat(this.form.discountEuro).toFixed(2);
			}

			params.active = this.form.active;

			this.$store.dispatch('promotion/save', params).then(res => {
				this.notifySuccessSave();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		activateModule() {
			this.$store.dispatch('promotion/activate').then(res => {
				this.notifySuccessActivate();
				this.init();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		deactivateModule() {
			this.$store.dispatch('promotion/deactivate').then(res => {
				this.notifySuccessDeactivate();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		notifySuccessActivate() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'De module terugkerende korting is geactiveerd!',
			});
		},
		notifySuccessDeactivate() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'De module terugkerende korting is gedeactiveerd!',
			});
		},

		notifySuccessSave() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'Je korting is opgeslagen!',
			});
		},
		createNotifyFailed() {
			this.$vs.notify({
				color: 'danger',
				title: 'Oops!',
				text: 'Er is iets fout gegaan.',
			});
		},
	}
}
</script>

<style scoped>
.btn-submit {
	width: 200px;
}

.shippingOptions {
	overflow-wrap: break-word;
}
</style>
